import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { AlertTriangle } from 'lucide-react';
interface DisclaimerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
}
export function DisclaimerModal({
  isOpen,
  onClose,
  onAccept
}: DisclaimerModalProps) {
  const [accepted, setAccepted] = useState(false);
  const handleAccept = () => {
    if (accepted) {
      onAccept();
    }
  };
  return <Modal isOpen={isOpen} onClose={onClose} size="md" data-id="element-34">
      <div className="space-y-6" data-id="element-35">
        {/* Warning Icon */}
        <div className="flex items-center space-x-3" data-id="element-36">
          <div className="flex-shrink-0 h-12 w-12 bg-amber-500/10 rounded-lg flex items-center justify-center border border-amber-500/20" data-id="element-37">
            <AlertTriangle className="h-6 w-6 text-amber-500" data-id="element-38" />
          </div>
          <h3 className="text-xl font-semibold text-white" data-id="element-39">
            Demonstration Tool Notice
          </h3>
        </div>

        {/* Disclaimer Content */}
        <div className="space-y-4 text-slate-300 leading-relaxed" data-id="element-40">
          <p className="text-base" data-id="element-41">
            ProvenanceOne is a demonstration tool designed to illustrate AI
            compliance assessment workflows. This platform is provided for
            evaluation and educational purposes only.
          </p>

          <div className="bg-navy-900 border border-slate-700 rounded-lg p-4 space-y-3" data-id="element-42">
            <h4 className="font-semibold text-white text-sm uppercase tracking-wide" data-id="element-43">
              Important Limitations
            </h4>
            <ul className="space-y-2 text-sm text-slate-400" data-id="element-44">
              <li className="flex items-start" data-id="element-45">
                <span className="text-amber-500 mr-2 mt-0.5" data-id="element-46">•</span>
                <span data-id="element-47">
                  Results are generated using simplified logic and mock data
                </span>
              </li>
              <li className="flex items-start" data-id="element-48">
                <span className="text-amber-500 mr-2 mt-0.5" data-id="element-49">•</span>
                <span data-id="element-50">
                  Gap analysis does not constitute legal or compliance advice
                </span>
              </li>
              <li className="flex items-start" data-id="element-51">
                <span className="text-amber-500 mr-2 mt-0.5" data-id="element-52">•</span>
                <span data-id="element-53">
                  No warranty is provided regarding accuracy or completeness
                </span>
              </li>
              <li className="flex items-start" data-id="element-54">
                <span className="text-amber-500 mr-2 mt-0.5" data-id="element-55">•</span>
                <span data-id="element-56">
                  User assumes all risk associated with use of this tool
                </span>
              </li>
              <li className="flex items-start" data-id="element-57">
                <span className="text-amber-500 mr-2 mt-0.5" data-id="element-58">•</span>
                <span data-id="element-59">Not intended for production compliance assessments</span>
              </li>
            </ul>
          </div>

          <p className="text-sm text-slate-400" data-id="element-60">
            For production-grade AI governance and compliance assessment,
            consult qualified legal and technical advisors familiar with
            applicable regulations in your jurisdiction.
          </p>
        </div>

        {/* Acceptance Checkbox */}
        <label className="flex items-start space-x-3 cursor-pointer group" data-id="element-61">
          <input type="checkbox" checked={accepted} onChange={e => setAccepted(e.target.checked)} className="mt-1 rounded border-slate-600 bg-navy-900 text-teal-500 focus:ring-teal-500 focus:ring-offset-navy-800 cursor-pointer" data-id="element-62" />
          <span className="text-sm text-slate-300 group-hover:text-white transition-colors" data-id="element-63">
            I understand this is a demonstration tool and accept that results
            are provided as-is, without warranty, and at my own risk.
          </span>
        </label>

        {/* Actions */}
        <div className="flex items-center justify-end space-x-3 pt-4 border-t border-slate-700" data-id="element-64">
          <Button variant="ghost" onClick={onClose} data-id="element-65">
            Cancel
          </Button>
          <Button onClick={handleAccept} disabled={!accepted} className="min-w-[140px]" data-id="element-66">
            Accept & Continue
          </Button>
        </div>
      </div>
    </Modal>;
}